export default "__VITE_ASSET__d0ef7003__"